import * as XLSX from "xlsx";

const paramSearchLabels = {
  createdAt: "Agendado",
  deliveryDate: "Fecha de Entrega",
};

export const generateExcelFromJSONData = (
  data,
  deliveryDate,
  paramSearch = null,
  fileName = null
) => {
  console.log("esto es data dentro de la función Descargar Excel", data);
  const dataToExcel = data.map((item) => {
    return {
      ID: Number(item.daily_id),
      NOMBRE: item.name?.toUpperCase(),
      DIRECCION: item.address.split(",")[0]?.toUpperCase(),
      DEPTO: item.address.split(",")[1]?.toUpperCase().trim(),
      COMUNA: item.city?.toUpperCase(),
      NUMERO:
        "(9) " +
        item.phone_number
          ?.replace(/\s/g, "")
          .substring(
            item.phone_number?.replace(/\s/g, "").length - 8,
            item.phone_number?.replace(/\s/g, "").length - 4
          ) +
        " " +
        item.phone_number
          ?.replace(/\s/g, "")
          .substring(
            item.phone_number?.replace(/\s/g, "").length - 4,
            item.phone_number?.replace(/\s/g, "").length
          ),
      PRODUCTO:
        item.products?.length > 0
          ? item.products
              .sort((a, b) => a.product_name.localeCompare(b.product_name))
              .map(
                (product) =>
                  product.quantity + " x " + product.product_name?.toUpperCase()
              )
              .join(" + ")
          : "",
      AROMA:
        item.products?.length > 0
          ? item.products
              .map((product) => product.variant?.toUpperCase())
              .join(" + ")
          : "",
      VALOR: item.amount ? item.amount : "",
      EST_PAGO:
        (
          item.first_payment_method ??
          item.payment_info_array?.[0]?.payment_method
        )?.toUpperCase() ?? "",
      OBSERVACIÓN:
        (
          item.last_delivery_note ??
          item.delivery_info_array?.[item.delivery_info_array.length - 1]
            ?.delivery_note
        )?.toUpperCase() ?? "",
      // MANGAS:
      //   item.products.length > 1
      //     ? item.products.reduce(
      //         (acc, curr) =>
      //           acc + curr.quantity * (curr.counts_as_manga ? 1 : 0),
      //         0
      //       )
      //     : item.products[0].quantity *
      //       (item.products[0].counts_as_manga ? 1 : 0),
    };
  });

  const dataSorted = dataToExcel.sort((a, b) => a.ID - b.ID);
  const worksheet = XLSX.utils.json_to_sheet(dataSorted);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

  const filterLabel = paramSearch ? `${paramSearchLabels[paramSearch]}` : "";
  const nameOfFile = fileName || `${filterLabel}_${deliveryDate}_pedidos.xlsx`;

  XLSX.writeFile(workbook, nameOfFile);
};

export const generateZMExcel = (data, searchDate, paramSearch = null) => {
  const dataToExcel = data.map((item) => {
    const productos =
      item.products?.length > 0
        ? item.products
            .map(
              (p) =>
                `${p.quantity} x ${p.product_name?.toUpperCase()} - ${p.variant?.toUpperCase()}`
            )
            .join(" | ")
        : "";
    const observaciones = item.seller_name
      ? `${productos} / ${item.seller_name?.toUpperCase()}`
      : productos;

    return {
      "Numero de tracking": item.daily_id,
      "Fecha de venta": searchDate
        ? searchDate.split("-").reverse().join("/")
        : "",
      "Valor declarado": "",
      "Peso declarado": "",
      Destinatario: item.name?.toUpperCase(),
      "Teléfono de contacto": item.phone_number?.replace(/\s/g, ""),
      Dirección: item.address?.toUpperCase(),
      Comuna: item.city?.toUpperCase(),
      Observaciones: observaciones,
      Email: "",
      Referencia: "",
      "4 Total a pagar": item.amount ?? "",
      "1 Logistica reversa": "",
    };
  });

  const dataSorted = dataToExcel.sort(
    (a, b) => Number(a["Numero de tracking"]) - Number(b["Numero de tracking"])
  );
  const worksheet = XLSX.utils.json_to_sheet(dataSorted);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

  const filterLabel = paramSearch ? `_${paramSearchLabels[paramSearch]}` : "";
  const nameOfFile = `ZM${filterLabel}_${searchDate}_pedidos.xlsx`;

  XLSX.writeFile(workbook, nameOfFile);
};

export const generateExcelFromObject = (arrayObjects, columnMap, fileName) => {
  const dataToExcel = arrayObjects.map((object) => columnMap(object));
  const worksheet = XLSX.utils.json_to_sheet(dataToExcel);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

  XLSX.writeFile(workbook, fileName);
};
